module.exports = __webpack_public_path__ + "img/us.50162f60.svg";